<template>
  <section class="tkn-body" id="tkn-body" ref="question_bus">
    <a-back-top :target="target" ref="backTop">
      <div class="back-top">
        <img src="./../assets/images/back_top.png" alt="" />
      </div>
    </a-back-top>
    <a-popover placement="leftTop" trigger="hover" v-if="!isZhongHang">
      <template slot="content">
        <div class="img-box">
          <img
            width="86px"
            class="qr-img"
            src="//cdn-cnc.17zuoye.cn/fs-resource/60b59c6f3cb75e3327789815.png"
            alt=""
          />
        </div>
        <div>
          <div class="qq-group">
            一起题库咨询QQ群：
          </div>
          <div class="qq-group">
            832168002
          </div>
        </div>
      </template>
      <div class="fix-icon"></div>
    </a-popover>
    <top-menu
      @subject="subject"
      :nomenu="nomenu"
      :noPick="noPick"
      :showSubject="showSubject"
      :assessment="assessment"
    ></top-menu>
    <Banner v-if="showBanner"></Banner>
    <div class="bus-container" :class="{ isFixed: titleFixed, haveScrollBar: haveScrollBar }">
      <slot name="bus"></slot>
    </div>
    <div class="tkn-body__wrap">
      <div class="tkn-content">
        <slot></slot>
      </div>
      <behavior-validation></behavior-validation>
      <assessment-modal></assessment-modal>
      <collection-tip v-if="showCollectModal && !isZhongHang"></collection-tip>
    </div>
    <div class="tkn-footer" :class="{ 'custom-footer': isBlockRegion }" v-if="!isZhongHang">
      <custom-footer v-if="isBlockRegion"></custom-footer>
      <Footer v-else></Footer>
    </div>
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import CustomFooter from '@/components/custom-footer/index.vue'
import TopMenu from '@/components/common/top-menu/index.vue'
import Banner from '@/components/common/Banner.vue'
import BehaviorValidation from '@/components/behavior-validation/index.vue'
import { throttle, debounce } from 'throttle-debounce'
import trackMixin from '../common/trackMixin.js'
import AssessmentModal from '@/apps/assessment/components/assessment-modal/index.vue'
import { BLOCK_REGIONS } from '@/components/model/topMenu'
import CollectionTip from '@/components/common/collection-tip/index.vue'
import TpAppNameMixins from '@/components/common/mixins/tp-appname'

export default {
  name: 'mainTemplate',
  mixins: [trackMixin, TpAppNameMixins],
  props: {
    msg: String,
    noPick: Boolean,
    showSubject: {
      default() {
        return true
      },
      type: Boolean
    },
    nomenu: {
      default() {
        return false
      },
      type: Boolean
    },
    breadcrumb: {
      default() {
        return true
      },
      type: Boolean
    },
    showBanner: {
      default() {
        return false
      },
      type: Boolean
    },
    assessment: {
      default() {
        return false
      },
      type: Boolean
    }
  },
  mounted() {
    this.titleFixed = false
    try {
      window.addEventListener('scroll', throttle(20, this.handleScroll), true)
    } catch (e) {
      console.log(e)
    }
    if (this.showCollectModal) {
    }
  },
  data() {
    return {
      titleFixed: false,
      list: [],
      haveScrollBar: false
    }
  },
  components: {
    TopMenu,
    Footer,
    Banner,
    BehaviorValidation,
    AssessmentModal,
    CustomFooter,
    CollectionTip
  },
  computed: {
    userInfo() {
      return this.$store.state.user_info
    },
    isBlockRegion() {
      let section =
        this.userInfo &&
        this.userInfo.regions &&
        this.userInfo.regions.length > 0 &&
        this.userInfo.regions[2]
      return (
        (section && BLOCK_REGIONS.includes(String(section.code))) ||
        ['minhang'].includes(String(this.tpAppName))
      )
    },
    isAdded() {
      return this.$store.state.isAdded
    },
    showCollectModal() {
      let usr = this.userInfo && this.userInfo.nickname
      let isPaper = this.$route.meta.name === '试卷'
      return usr && isPaper && !this.isAdded
    },
    // 中行用户
    isZhongHang() {
      const zhongHangId = 'd5bf4a5ff8876b0f0b5a53f91b65c43a'
      return (
        this.userInfo &&
        this.userInfo.customer_ids &&
        this.userInfo.customer_ids.includes(zhongHangId)
      )
    }
  },
  watch: {
    userInfo: {
      handler() {
        if (this.showCollectModal) {
          // 埋点
          window['sensors'].track('TIKU_collect_exp', {
            active: '收藏有奖浮窗'
          })
        }
      }
    }
  },
  methods: {
    subject(val) {
      // console.log(val)
    },
    target() {
      return document.getElementById('app')
    },
    handleScroll() {
      let offsetTop = this.$refs.question_bus && this.$refs.question_bus.getBoundingClientRect().top
      let element = document.getElementById('app')
      let offsetWidth = element.offsetWidth
      let clientwidth = element.clientWidth
      this.titleFixed = offsetTop < -78
      if (offsetWidth - clientwidth > 0 && this.titleFixed) {
        this.haveScrollBar = true
      } else {
        this.haveScrollBar = false
      }
    }
  }
}
</script>
<style scoped lang="scss">
.back-top {
  width: 48px;
  height: 48px;
  line-height: 40px;
  background: rgba(255, 255, 255, 1);
  text-align: center;
  font-size: 24px;
  border-radius: 4px;
  img {
    width: 20px;
  }
}
.isFixed {
  position: fixed !important;
  top: 0px !important;
}
.bus-container {
  position: absolute;
  right: 0;
  top: 84px;
  z-index: 50;
}
#tkn-body .ant-back-top {
  right: 48px;
  bottom: 258px;
}
.haveScrollBar {
  right: 8px !important;
}
.tkn-body {
  min-width: 1270px;
  height: 100%;
}
.custom-footer {
  height: 75px;
}
.fix-icon {
  z-index: 999;
  position: fixed;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  right: 40px;
  bottom: 194px;
  cursor: pointer;
  background-color: #386bff;
  background-image: url('../assets/images/qq_tip.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 25px 23px;
  &:hover {
    background-color: #5681ff;
  }
}
.qq-group {
  font-size: 12px;
  font-weight: 400;
  color: #4d5271;
  line-height: 15px;
  text-align: center;
}
.img-box {
  width: 100%;
  display: flex;
  justify-content: center;
}
.qr-img {
  margin: 0 auto 8px;
  padding-top: 4px;
}
</style>
